export default "__VITE_ASSET__Bk8jbEkm__"